import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "./context/AuthContext";

export default function ProtectedRoute({ children }) {
  const {currentUser, loading} = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/portal" state={{ from: location }} replace />;
  }

  return children;
}